<template>
  <div>
    <a v-for="download in downloads" class="download" :href="download.Original" target="_blank" :key="download.Original" >
        <p v-html="$root.md(download.Captions[0])"/>
        <p v-html="getExtension(download.Original)"/>
    </a>
  </div>
</template>

<script>
export default {
  props: {
    downloads: Array
  },
  methods: {
    getExtension (file) {
      const f = file.split(/\./)
      return `&darr; ${f[f.length - 1]}`
    }
  }
}
</script>

<style scoped lang="scss">
@import '../main';

.download {
  margin: auto;
  width: 100%;
  height: var(--menuwidth-hidden);
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  user-select: none;
  cursor: pointer;
  color: white;
  border-bottom: 1px solid var(--line-color);
  &:first-child {
    border-top: 1px solid var(--line-color);
  }
  @include hover() {
    color: var(--link-hover-color);
  }
}

p {
    margin: 0;
    z-index: 1;
    flex-basis: 4em;
    text-align: center;
    white-space: nowrap;
    padding: 0;
    &:first-of-type {
      text-align: left;
      pointer-events: none;
      text-transform: uppercase;
    }
    &:last-of-type {
      text-transform: uppercase;
      @include headerfont;
      text-align: right;
      pointer-events: none;
    }
}

</style>



// WEBPACK FOOTER //
// src/components/Filedownload.vue